import axios from 'axios';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import ApiKey from '../../Components/api/ApiKey';
import BaseApi from '../../Components/api/BaseApi';
// components
import Sidebar from '../../Components/employersSide/Sidebar';

import { logOutIfTokenExpired, resultInfo } from '../../Components/helpers';

import { Box, Button, Container, Flex, Spinner } from '@radix-ui/themes';
import { JobApplicantsHeader } from './job-applicants-header';
import { JobApplicantsTable } from './job-applicators-table';
import { useJobApplicants } from './job-applicants-provider';
import { JobApplicantsAppliedInfo } from './job-applicants-applied-info';
import { JobApplicantsNav } from './job-applicants-nav';
import { JobApplicantsStatistic } from './job-applicants-statistic';
import { JobToggleStatus } from './job-toggle-status';
import { JobApplicantsSendEmail } from './job-applicants-send-email/job-applicants-send-email';
import { observer } from 'mobx-react-lite';

const JobApplicantsView = () => {
   const { t } = useTranslation('global');
   const { slug } = useParams();
   const navigate = useNavigate();
   const jobApplicants = useJobApplicants();
   const userType = Cookies.get('user_type');
   const tokenKey = Cookies.get('tokenClient');

   useEffect(() => {
      if (slug) {
         jobApplicants.loadAccDetail({ slug });
      }
   }, [jobApplicants, slug]);

   const curr = Cookies.get('curr');

   if (!jobApplicants.jobInfo && jobApplicants.loadAccDetailState.status === 'pending') {
      return (
         <Container>
            <Flex justify="center" align="center" height="516px">
               <Spinner size="3"></Spinner>
            </Flex>
         </Container>
      );
   }

   return (
      <>
         {
            <>
               <div className="container IADsecondSegment">
                  <div className="row">
                     <div className="col-lg-3 col-md-3 mt-4">
                        <Sidebar />
                     </div>
                     <div className="col-lg-9 col-md-9 mb-5 IADMainBx">
                        <JobApplicantsHeader />
                        <div className="JobseekerProfileBx">
                           {/* {Nav} */}
                           <JobApplicantsNav />
                           <div className="JobseekerProfileDetails">
                              {/* { Statistic View} */}
                              <JobToggleStatus />
                              <JobApplicantsStatistic />

                              {/* TABLE */}
                              <Flex direction="column" gap="4" mt="6">
                                 <ul className="nav JobseekersTabs" id="myTab" role="tablist">
                                    <li>
                                       <span
                                          role="tab"
                                          id="jobseekers-tab"
                                          aria-selected="true"
                                          data-bs-toggle="tab"
                                          className="Calcultn"
                                          aria-controls="jobseekers-tab-pane"
                                          data-bs-target="#jobseekers-tab-pane"
                                       >
                                          Список відгуків
                                       </span>
                                    </li>
                                 </ul>
                                 <JobApplicantsAppliedInfo />
                                 <JobApplicantsTable />
                              </Flex>
                              {jobApplicants.showSendEmail && (
                                 <Box mt="4">
                                    <Button
                                       size="3"
                                       onClick={() => {
                                          jobApplicants.toggleEmailDialog(true);
                                       }}
                                    >
                                       Надіслати лист
                                    </Button>
                                 </Box>
                              )}
                              <JobApplicantsSendEmail />
                              <div className="JobseekersTabsBx">
                                 <div className="tab-content" id="myTabContent">
                                    <div
                                       tabIndex={0}
                                       role="tabpanel"
                                       id="jobseekers-tab-pane"
                                       aria-labelledby="jobseekers-tab"
                                       className="tab-pane fade show active"
                                    >
                                       {/* <div className="JobseekersTabsContent">
                                          <JobApplicantsAppliedInfo></JobApplicantsAppliedInfo>
                                       </div> */}
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </>
         }
      </>
   );
};

export const JobApplicants = observer(JobApplicantsView);
